import { ContractActions } from "../actions";

const initialState = {
  contracts: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  contractsHistory: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  contract: null,
  debtLetterBatchImports: {
    rows: [],
    rowCount: 0,
    pageCount: 1,
  },
};

export default function contract(state = initialState, action) {
  switch (action.type) {
    case ContractActions.ACTION_SAVE_CONTRACTS:
      return {
        ...state,
        contracts: action.payload,
      };
    case ContractActions.ACTION_SAVE_CONTRACTS_HISTORY:
      return {
        ...state,
        contractsHistory: action.payload,
      };
    case ContractActions.ACTION_STATUS_PDF:
      return {
        ...state,
        contracts: action.payload,
      };
    case ContractActions.ACTION_SAVE_CONTRACTS_CONSOLIDATED:
      return {
        ...state,
        contracts: action.payload,
      };
    case ContractActions.ACTION_SAVE_CONTRACT:
      return {
        ...state,
        contract: action.payload,
      };
    case ContractActions.ACTION_CLEAR_CONTRACTS_LIST:
      return {
        ...state,
        contracts: initialState.contracts,
      };
    case ContractActions.ACTION_SAVE_DEBT_LETTER_BATCH_IMPORTS:
      return {
        ...state,
        debtLetterBatchImports: action.payload,
      };
    default:
      return state;
  }
}

export function getContracts(state) {
  return state.contract.contracts;
}

export function getContractsHistory(state) {
  return state.contract.contractsHistory;
}

export function getContract(state) {
  return state.contract.contract;
}

export function getDebtLetterBatchImports(state) {
  return state.contract.debtLetterBatchImports;
}
